const FloatingInput = ({
  children,
  id,
  name,
  type = "text",
  placeholder = "",
  value,
  onChange,
  onBlur,
  error,
  title,
  className = "",
  required,
  disabled,
  touched,
  ...props
}) => {
  return (
    <div className="relative">
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        placeholder=" "
        title={title}
        className={`floatingInput peer block rounded-lg px-3 pb-2 pt-5 w-full text-sm text-gray-700 border appearance-none focus:outline-none focus:ring-1 focus:ring-red-500
                ${
                  touched && error
                    ? "outline-none ring-1 ring-red-500"
                    : "border-gray-300"
                } ${className}`}
        {...props}
      />
      {children}
    </div>
  );
};

export default FloatingInput;
